import { Controller } from "@hotwired/stimulus"

// Swaps the claim document chrome (CMS-1500 vs UB-04) when the operator
// changes claim type. All of the visual work is done in CSS via
// group-data-[claim-type=...] variants on the section; this controller only
// keeps the section's data attribute in sync with the select, plus mirrors an
// explicit claim-level Date of service change into the hidden per-line dates.
export default class extends Controller {
  update(event) {
    this.element.dataset.claimType = event.target.value
  }

  // Service-line rows re-submit their persisted dates through hidden
  // [data-sca-line-date] fields, so repricing alone never rewrites them.
  // Changing the visible claim-level Date of service is the operator's
  // explicit choice of one date for the whole claim: mirror it into every
  // row's hidden pair. Clearing the field syncs nothing — blank must not
  // erase persisted line dates mid-edit.
  syncServiceDates(event) {
    const value = event.target.value
    if (!value) return
    this.element.querySelectorAll("[data-sca-line-date]").forEach((field) => {
      field.value = value
    })
  }
}
